import MultiProvinceFilter from "../../Shared/MultiProvinceFilter";
import { PaginatedVacationDaysQueryVariables } from "@/graphql/__generated__/graphql";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables: PaginatedVacationDaysQueryVariables) => void;
}

/**
 * Vacation Days specific province filter configuration
 */
const vacationDaysProvinceConfig = {
  paginationStateKey: "paginatedVacationDays" as keyof PaginationState,
  buildQueryVariables: (
    displayAmount: number,
    filters: any,
    provinces: string[] | null
  ): PaginatedVacationDaysQueryVariables => ({
    first: displayAmount,
    filters: {
      activeFrom: filters.activeFrom || null,
      days: filters.days || null,
      lengthOfEmployment: filters.lengthOfEmployment || null,
      provinces,
    },
  }),
  extractFilters: (paginationState: any) => paginationState?.filters || {},
};

function VacationDaysProvincesDropdown(props: Props) {
  const { displayAmount, handleSubmitClick } = props;

  return (
    <MultiProvinceFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={vacationDaysProvinceConfig}
    />
  );
}

export default VacationDaysProvincesDropdown;
